var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedColor && _vm.selectedColor.id)?_c('div',{staticClass:"color-solutions-more-options-modal"},[_c('try-it-on',{attrs:{"compare-product-id":_vm.selectedColor.id},on:{"select":_vm.changeColor,"cancel":_vm.hideModal}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }